export enum RejectReasonEnum {
    None = 0,
    RejectDocument = 1
}
